export default __webpack_public_path__ + "static/media/magnifier.a1eb52a9.svg";